import React, { Component } from 'react'
import RangeSelector from '../range_selector'
import { appStrings } from '../../common/strings/app_strings'

class DashNav extends Component {
    render() {
        const {
            renderButtonBar,
            viewport,
        } = this.props
        const { hrs, hours } = appStrings.dashNav
        const hourString = window.innerWidth < 350 ? hrs : hours

        return (
            <div className="personal-dash-nav">
                <div className="range-selector-row">
                    <RangeSelector
                        title={this.props.title}
                        onSelect={this.props.handleRangeSelect}
                        onClickForward={this.props.onClickForward}
                        onClickBackward={this.props.onClickBackward}
                        defaultSelectedOption={this.props.defaultSelectedOption}
                        options={[
                            { key: ['Day', 'Day'], label: 'Day' },
                            { key: ['Week', 'Week'], label: 'Week' },
                            { key: ['Month', 'Month'], label: 'Month' },
                            { key: ['Day', 'Today'], label: 'Today' },
                        ]}
                    />
                </div>
                <div className="total-time">
                    <span className="count">{this.props.totalHrs}</span>
                    {hourString}
                </div>
                <div
                    className={`buttons range-button-bar ${viewport &&
                        viewport.display === "member" &&
                        "range-button-bar-member"}`}
                >
                    {renderButtonBar()}
                </div>
            </div>
        )
    }
}

export default DashNav


// WEBPACK FOOTER //
// ./src/components/layout/dash_nav.jsx